export interface PreloadControllerData {
  images: string[];
}

export interface PreloadControllerProps extends PreloadControllerData {}
